var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6663 2.66663C13.7709 2.66663 14.6663 3.56206 14.6663 4.66663V11.3333C14.6663 12.4379 13.7709 13.3333 12.6663 13.3333H3.33301C2.22844 13.3333 1.33301 12.4379 1.33301 11.3333V4.66663C1.33301 3.56206 2.22844 2.66663 3.33301 2.66663H12.6663ZM2.66634 7.99996V11.3333C2.66634 11.7015 2.96482 12 3.33301 12H12.6663C13.0345 12 13.333 11.7015 13.333 11.3333V7.99996H2.66634ZM2.66634 5.33329H13.333V4.66663C13.333 4.29844 13.0345 3.99996 12.6663 3.99996H3.33301C2.96482 3.99996 2.66634 4.29844 2.66634 4.66663V5.33329Z",
    fill: "#059669"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/cardIcon.69e10cab.svg";
export { ForwardRef as ReactComponent };